const isOverseas = process.env.REACT_APP_SITE === 'overseas';
export const t = (zh, en) => (isOverseas ? en : zh);
export { isOverseas };
